import React from 'react'
import { ListGroup, Card } from 'react-bootstrap'
import SEO from '../components/SEO'

function AccountScreen() {
    return (
        <>
            <SEO 
                title="Account Settings - PCRAssist"
                description="Manage your PCRAssist account settings, subscription details, and usage statistics."
                canonicalUrl="/account"
            />
            <div>
                <Card>
                    <Card.Header>Account Information</Card.Header>
                    <ListGroup>
                        <ListGroup.Item>First name</ListGroup.Item>
                        <ListGroup.Item>Jos</ListGroup.Item>
                    </ListGroup>
                </Card>
            </div>
        </>
    )
}

export default AccountScreen